import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * アイコンカラム
 *【アイコン:icon:string】
 *【代替アイコン:alternateIcon:string】
 *【サイズ:size:number】
 *【色:color:string】
 *【非活性:disabled:boolean】
 *【表示条件:visible:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-icon-column',
  templateUrl: './icon-column.html',
  styles: [`
    
  `]
})
export class IconColumn extends BaseWidget {
  /**
   * 項目添字
   */
  @Input() index:number

  /**
   * リスト内容
   */
  @Input() records:any[]

  /**
   * アイコン
   */
  @Input() icon:string

  /**
   * 代替アイコン
   */
  @Input() alternateIcon:string

  /**
   * サイズ
   */
  @Input() size:number

  /**
   * 色
   */
  @Input() color:string

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get htmlId():string {
    return `${this.id}[${this.index}]`
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/icon-column/icon-column.component.ts